<script lang="ts">
  import { _ } from "svelte-i18n";
  import { get } from "svelte/store";
  import Typography from "$lib/components/Typography/Typography.svelte";

  export let label = "New Arrival";

  const t = get(_);
</script>

<style lang="scss">
  .badge {
    background-color: $surface-alt;
    width: max-content;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0.25rem 0.5rem 0.1875rem;
  }
</style>

<div class="badge">
  <Typography component="p" variant="caption1" theme="on-surface">
    {t(label).toUpperCase()}
  </Typography>
</div>
